import memberPrePaidBookingsTemplate from './member_pre_paid_bookings.html';

function MemberPrePaidBookingsDirective(PaginationService) {
    'ngInject';

    function link(scope, element, attrs) {

        scope.pagination = PaginationService.initialise({page_size: 10, max_size: 5});

        const getBookings = () =>
            scope.getPrePaidBookings({}).then(pre_paid_bookings => PaginationService.update(scope.pagination, pre_paid_bookings.length))
        ;


        scope.$watch('member', () => {
            if (!scope.pre_paid_bookings) {
                return getBookings();
            }
        });


        scope.$on('booking:cancelled', event =>
            scope.getPrePaidBookings({}).then(pre_paid_bookings => PaginationService.update(scope.pagination, pre_paid_bookings.length))
        );


        if (scope.member) {
            return getBookings();
        }
    }

    return {
        templateUrl: memberPrePaidBookingsTemplate.id,
        scope: {
            member: '='
        },
        controller: 'MemberBookings',
        link
    };

}

angular
    .module('BBMember')
    .directive('bbMemberPrePaidBookings', MemberPrePaidBookingsDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/member-pre-paid-bookings/member_pre_paid_bookings.directive.js